module.exports = function getResource(label, vars = []) {
    const resources = {
        accept: 'Accept',
        termsConditions: 'Terms & Conditions',
        mustAcceptTermsConditions: 'You must accept terms and conditions first.',
        alreadyEnrolledFlash: 'You are already enrolled in flash.',
        buttonCTAEnrolled: 'Already Enrolled',
        buttonCTAEnrollNow: 'Enroll Now',
        flashTermsModalTitle: 'Flash Terms & Conditions'
    };
    return resources[label];
};
